import React from 'react';
import CryptoWithdrawForm from './WithdrawOptions/CryptoWithdrawForm';
const SendCryptoModal = ({ isOpen, onClose, initialCrypto }) => {
   if (!isOpen) return null;
   // Preparar los datos necesarios para CryptoWithdrawForm
   const cryptoData = {
      name: initialCrypto?.name || 'Bitcoin',
      code: initialCrypto?.currency || 'BTC',
      image: initialCrypto?.image || '/assets/img/icon_btc.svg'
   };
   // Generar una dirección de ejemplo (o usar una real si está disponible)
   const exampleAddress = '0x742d35Cc6634C0532925a3b844Bc454e4438f44e';
   const handleOverlayClick = (e) => {
      if (e.target.className === 'modal_overlay') {
         onClose();
      }
   };
   // Componente personalizado para mostrar el título correcto
   const CustomCryptoWithdrawForm = (props) => {
      // Renderizar el componente CryptoWithdrawForm pero personalizar su título
      return (
         <div className="send-crypto-form">
            {/* Si orderCompleted es true, mostrar la pantalla de éxito (sin cambios) */}
            {props.orderCompleted ? (
               // Contenido existente para completado
               <div className='ppt_deposit_item text-center'>
                  {/* ... contenido de completado existente ... */}
               </div>
            ) : !props.showConfirmation ? (
               // Primera pantalla - Formulario de envío (modificar título aquí)
               <>
                  <h3 className="ppt_form_title mb-3 text-center">
                     Send {/* Cambiado de "Withdraw" a "Send" */}
                     <img
                        src={process.env.PUBLIC_URL + props.selectedCrypto.image}
                        alt={props.selectedCrypto.name}
                        style={{ width: '28px', height: '28px', marginLeft: '8px', verticalAlign: 'middle' }}
                     />
                  </h3>
                  {/* Resto del contenido del formulario sin cambios */}
                  <div className="d-flex align-items-center justify-content-center mb-3">
                     {/* ... resto del contenido ... */}
                  </div>
                  {/* ... resto del contenido ... */}
               </>
            ) : (
               // Pantalla de confirmación (sin cambios)
               <div className="confirmation-screen">
                  {/* ... contenido de confirmación existente ... */}
               </div>
            )}
         </div>
      );
   };
   return (
      <div className="modal_overlay" onClick={handleOverlayClick}>
         <div className="modal_content">
            <div className="modal_content_header">
               <span onClick={onClose} className="modal_content_header_close"></span>
            </div>
            <div className="modal_content_body">
               {/* Usar nuestro componente personalizado en lugar de CryptoWithdrawForm directamente */}
               <CryptoWithdrawForm
                  selectedCrypto={cryptoData}
                  amount="150"
                  cryptoAmount="0.005"
                  address={exampleAddress}
                  handleAmountChange={() => { }}
                  handleBack={onClose}
                  // Añadir prop para indicar que es un envío, no un retiro
                  isSendOperation={true}
               />
            </div>
         </div>
      </div>
   );
};
export default SendCryptoModal;